import
  React
from 'react';

import {
  useHistory
} from 'react-router-dom';

import
  PropTypes
from 'prop-types';

import {
  ColorSvg,
  Text,
  VContainerH,
  VFillContainer,
  VFillContainerVH
} from '@vodacom/web-common';

import {
  withScreenViewTagging
} from 'hocs';

import {
  CustomColors,
  Icons
} from '../../../../constants';

import {
  PrimaryButton,
  SecondaryButton
} from 'components';

import {
  useRedirectHandler
} from 'helpers';

const ConfirmationFormUI = (props) => {

  const history = useHistory();
  const redirectHandler = useRedirectHandler();
  ConfirmationFormUI.pageName = props.pageName;
  ConfirmationFormUI.tagViewData = props.tagViewData;

  return (

    <VFillContainerVH
      padding={'20% 24px 0'}
      height={'100%'}
      boxSizing={'border-box'}>

      <ColorSvg
        src={Icons.InfoCircle}
        color={CustomColors.Grey11}
        height={props.iconHeight}
        width={props.iconWidth}
        margin={props.iconMargin} />

      {
        props.title &&
        <Text
          fontSize={props.titleFontSize}
          fontWeight={'bold'}
          textAlign={'center'} >

          {props.title}
        </Text>
      }

      <VContainerH
        overflow={'auto'}
        minHeight={'30%'} >

        <Text
          font-family={props.messageFontFamily}
          fontSize={props.messageFontSize}
          fontWeight={props.messageWeight}
          color={CustomColors.Grey9}
          textAlign={'center'}
          padding={'16px 0'}
          whiteSpace={'pre-wrap'}
          dangerouslySetInnerHTML={{
            __html: props.description
          }}/>
      </VContainerH>

      { props.showLegalSection &&

        <VFillContainer
          justifyContent={'flex-end'}
          margin={'32px'}>

          <Text
            textAlign={'center'}
            color={CustomColors.Grey9} >

            {props.disclaimer}
          </Text>

          <Text
            textDecoration={'underline'}
            textAlign={'center'}
            color={CustomColors.Blue1}
            onClick={() => {

              if (props.isPrimaryLoading) {
                return;
              }

              redirectHandler(
                history.location,
                `/redirect?targetUrl=${props.legalPath}&isZeroRated=true`,
                true
              );
            }} >

            {props.legalText}
          </Text>

        </VFillContainer>
      }

      <PrimaryButton
        activeBackgroundColor={props.buttonColor}
        activeBorderColor={props.buttonColor}
        width={'100%'}
        maxWidth={'320px'}
        margin={'auto 0 0'}
        text={props.buttonText}
        isEnabled={props.isPrimaryEnabled}
        showSpinner={props.isPrimaryLoading}
        onClick={props.onPrimaryClick}/>

      <SecondaryButton
        margin={'16px 0'}
        border={'2px solid'}
        text={'Cancel'}
        isEnabled={props.isSecondaryEnabled}
        onClick={props.onSecondaryClick}/>
    </VFillContainerVH>
  );
};

ConfirmationFormUI.propTypes = {
  padding: PropTypes.string,
  boxSizing: PropTypes.string,
  maxWidth: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  iconHeight: PropTypes.string,
  iconWidth: PropTypes.string,
  iconMargin: PropTypes.string,
  title: PropTypes.string,
  titleFontSize: PropTypes.string,
  messageFontFamily: PropTypes.string,
  messageWeight: PropTypes.string,
  messageFontSize: PropTypes.string,
  buttonText: PropTypes.string,
  buttonColor: PropTypes.string,
  showLegalSection: PropTypes.bool,
  disclaimer: PropTypes.string,
  legalText: PropTypes.string,
  legalPath: PropTypes.string,
  description: PropTypes.string,
  onPrimaryClick: PropTypes.func,
  isPrimaryLoading: PropTypes.bool,
  isPrimaryEnabled: PropTypes.bool,
  onSecondaryClick: PropTypes.func,
  isSecondaryEnabled: PropTypes.bool,
  pageName: PropTypes.string,
  tagViewData: PropTypes.object
};

ConfirmationFormUI.defaultProps = {
  padding: '0 24px',
  boxSizing: 'border-box',
  maxWidth: '101%',
  width: '100%',
  height: '100%',
  iconHeight: '80px',
  iconWidth: '80px',
  iconMargin: '32px',
  title: 'About your voucher',
  titleFontSize: '20px',
  messageFontFamily: 'Roboto',
  messageWeight: 'normal',
  messageFontSize: '16px',
  buttonText: 'Proceed',
  buttonColor: CustomColors.Red1,
  showLegalSection: true,
  disclaimer: 'By selecting \'Proceed\' you agree to',
  legalText: 'Terms and Conditions.',
  legalPath: 'https://www.vodacom.co.za/vodacom/terms/voucher-advance',
  description: '',
  onPrimaryClick: () => {},
  isPrimaryLoading: false,
  isPrimaryEnabled: true,
  onSecondaryClick: () => {},
  isSecondaryEnabled: true,
  pageName: '',
  tagViewData: {}
};

export const ConfirmationForm = withScreenViewTagging(ConfirmationFormUI);